import { Component, effect, input, model, output, signal, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-orders-tree-list-pagination',
  templateUrl: './orders-tree-list-pagination.component.html',
  styleUrl: './orders-tree-list-pagination.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrdersTreeListPaginationComponent {
  totalPages = input.required<number>();
  currentDataLength = input.required<number>();
  currentPage = model.required<number>();
  pageSize = model.required<number>();
  readonly pageDraft = signal<string>('1');
  readonly isEditingPage = signal<boolean>(false);
  readonly syncPageDraft = effect(() => {
    if (this.isEditingPage()) return;
    this.pageDraft.set(String(this.currentPage()));
  });

  pageSizeOptions = input<{ id: number; name: string }[]>([
    { id: 25, name: '25' },
    { id: 50, name: '50' },
    { id: 100, name: '100' },
    { id: 0, name: 'Tous' },
  ]);
  pageChange = output<number>();
  pageSizeChange = output<number>();

  onPageInputFocus(): void {
    this.isEditingPage.set(true);
  }

  onPageInputChange(value: unknown): void {
    this.pageDraft.set(value === null || value === undefined ? '' : String(value));
  }

  commitPageInput(): void {
    this.isEditingPage.set(false);
    const raw = this.pageDraft().trim();
    const page = Number.parseInt(raw, 10);
    if (!raw || Number.isNaN(page)) {
      this.pageDraft.set(String(this.currentPage()));
      return;
    }
    this.goToPage(page);
  }

  goToPage(page: number) {
    const pageIndex = Math.max(1, Math.min(page, this.totalPages()));
    if (pageIndex === this.currentPage()) {
      this.pageDraft.set(String(pageIndex));
      return;
    }
    this.currentPage.set(pageIndex);
    this.pageChange.emit(pageIndex);
  }

  goToPreviousPage() {
    if (this.currentPage() > 1) this.goToPage(this.currentPage() - 1);
  }

  goToNextPage() {
    if (this.currentPage() < this.totalPages()) this.goToPage(this.currentPage() + 1);
  }

  changePageSize(size: number) {
    this.pageSize.set(size);
    this.pageSizeChange.emit(size);
  }
}
